<div class="mat-elevation-z4">
    <mat-toolbar class="table-header">
        <mat-toolbar-row>

            <button type="button" class="btn btn-success btn-sm mr-1"
                [disabled]="!selectedModel || selectedModel.status.codigo != 2 || selectedModel?.monitoramentoFinMan === true || selectedModel?.monitoramentoFinAut === true"
                *ngIf="permissoes.avaliar" (click)="avaliar(selectedModel.id)">
                <i class="fas fa-check"></i> Avaliar
            </button>
            
            <button type="button" class="btn btn-primary btn-sm mr-1"
                [disabled]="!selectedModel || (selectedModel.status.codigo == 1) || (selectedModel.status.codigo == 2) || (selectedModel.status.codigo == 3) || (selectedModel.status.codigo == 6) || (selectedModel?.monitoramentoFinMan === true || selectedModel?.monitoramentoFinAut === true)"
                *ngIf="permissoes.monitorar" (click)="monitorar(selectedModel.id)">
                <i class="fas fa-chart-line"></i> Monitorar
            </button>

            <button type="button" class="btn btn-danger btn-sm mr-1"
                [disabled]="!selectedModel || (selectedModel.status.codigo != 1 && selectedModel.status.codigo != 2 && selectedModel.status.codigo != 3 && selectedModel.status.codigo != 4)"
                *ngIf="permissoes.cancelar" (click)="cancelar(selectedModel)">
                <i class="fas fa-ban"></i> Cancelar
            </button>
            
            <button type="button" class="btn btn-info btn-sm mr-1" [disabled]="!selectedModel"
                (click)="visualizar(selectedModel?.id)" *ngIf="permissoes.visualizar">
                <i class="far fas fa-eye"></i>
                Visualizar
            </button>
            
            <button type="button" class="btn btn-info btn-sm mr-1" [disabled]="!selectedModel" (click)="imprimir(selectedModel.id)"
                [hidden]="!permissoes.imprimir">
                <i class="far fas fa-print"></i>
                Imprimir
            </button>

            <button type="button" class="btn btn-info btn-sm mr-1" [disabled]="!selectedModel" (click)="imprimirRelatoria(selectedModel.id)"
                [hidden]="!permissoes.relatoria">
                <i class="far fas fa-print"></i>
                Relatoria
            </button>

            <button type="button" class="btn btn-warning btn-sm mr-1"
                [disabled]="!selectedModel"
                *ngIf="permissoes.finalizarMonitoramento && selectedModel?.monitoramentoFinMan === false && selectedModel?.monitoramentoFinAut === false && selectedModel?.status?.codigo !== 6"
                (click)="finalizarMonitoramento(selectedModel)">
                <i class="fas fa-times"></i> Finalizar Monitoramento
            </button>

            <button type="button" class="btn btn-success btn-sm mr-1"
                [disabled]="!selectedModel"
                *ngIf="permissoes.finalizarMonitoramento && selectedModel?.monitoramentoFinMan === true && selectedModel?.monitoramentoFinAut === false && selectedModel?.status?.codigo !== 6"
                (click)="habilitarMonitoramento(selectedModel)">
                <i class="fas fa-check-circle"></i> Habilitar Monitoramento
            </button>

            <button type="button" class="btn btn-info btn-sm mr-1" [disabled]="!selectedModel"
                (click)="gerarVersao(selectedModel)" *ngIf="permissoes.gerarNovaVersao">
                <i class="fas fa-code-branch"></i>
                Registrar versão do Plano
            </button>

            <button type="button" class="btn btn-info btn-sm mr-1" [disabled]="!selectedModel"
                (click)="historicoVersoes(selectedModel)" *ngIf="permissoes.imprimir && permissoes.relatoria">
                <i class="fas fa-history"></i>
                Histórico de versões
            </button>

            <!--Botões de ações -->
            <span class="fill-remaining-space"></span>

            <div class="input-group input-group-sm" style="width: 100%; display: flex; justify-content: flex-end;">
                <input type="text" name="table_search" class="form-control float-right" style="max-width:30%;"
                    (keyup.enter)="filtrarPorNumero()" placeholder="Pesquisar por Número Osa" [(ngModel)]="numeroOsa" />
                <div class="input-group-append">
                    <button type="button" class="btn btn-info" (click)="filtrarPorNumero()">
                        <i class="fas fa-search"></i>
                    </button>
                </div>
                <div class="input-group-append">
                    <button class="btn btn-default" type="button" data-toggle="collapse" data-target="#collapseExample"
                        aria-expanded="false" aria-controls="collapseExample">
                        <i class="fas fa-filter"></i> Filtro Avançado
                    </button>
                </div>
            </div>
        </mat-toolbar-row>
    </mat-toolbar>
    <div>
        <ng-content></ng-content>
    </div>

    <table mat-table [dataSource]="dataSource" #tabela1="matSort" matSort matSortDisableClear
        (matSortChange)="sortData($event)" matSortActive="numeroOsa" matSortDirection="asc" *ngIf="!semDados"
        class="w-100 mat-elevation-z8">

        <!-- select Column -->
        <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
                <mat-checkbox (click)="$event.stopPropagation()" color="primary" (change)="selecionar(element);"
                    [checked]="selectedModel?.id === element.id">
                </mat-checkbox>
            </td>
        </ng-container>
        <!-- numero Osa -->
        <ng-container matColumnDef="numeroOsa">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Núm. Doc. Associado
            </th>
            <td mat-cell *matCellDef="let element">
                {{ element?.osaExecucao.osa?.numero }}
            </td>
        </ng-container>
        <!-- ug Auditada -->
        <ng-container matColumnDef="ug">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                UG
            </th>
            <td mat-cell *matCellDef="let element">
                {{ element?.unidadeGestora?.sigla }}
            </td>
        </ng-container>
        <!-- referencia -->
        <ng-container matColumnDef="referencia">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Referência
            </th>
            <td mat-cell *matCellDef="let element">
                {{ element?.tipo.descricao }}
            </td>
        </ng-container>
        <!-- tipo de auditoria -->
        <ng-container matColumnDef="tipoAuditoria">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Tipo de Auditoria
            </th>
            <td mat-cell *matCellDef="let element">
                {{ element?.osaExecucao.osa.planejamento &&
                element?.osaExecucao.osa.planejamento?.opa?.tipoAuditoria?.nome }}
            </td>
        </ng-container>
        <!-- prazo Final -->
        <ng-container matColumnDef="prazoFinal">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Prazo Final
            </th>
            <td mat-cell *matCellDef="let element">
                <p *ngIf="!element?.prazoFinal">
                    -
                </p>
                <p *ngIf="element?.prazoFinal">
                    {{ element?.prazoFinal | date: "dd/MM/yyyy" }}
                </p>
            </td>
        </ng-container>

        <!-- ações a monitorar -->
        <ng-container matColumnDef="monitorar">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Ações a <br> Monitorar
            </th>
            <td mat-cell *matCellDef="let element">
                {{ element?.monitorar? "Sim" : "Não" }}
            </td>
        </ng-container>

        <!-- status -->
        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Status
            </th>
            <td mat-cell *matCellDef="let element">
                <span *ngIf="element?.status?.nome === 'EmElaboracao'" class="badge bg-success text-xs">Em Elaboração</span>
                <span *ngIf="element?.status?.nome === 'EmAvaliacao'" class="badge bg-warning text-xs">Em Avaliação</span>
                <span *ngIf="element?.status?.nome === 'Avaliado'" class="badge bg-info text-xs">Avaliado</span>
                <span *ngIf="element?.status?.nome === 'EmExecucao'" class="badge bg-success text-xs">Em Execução</span>
                <span *ngIf="element?.status?.nome === 'Concluido'" class="badge bg-info text-xs">Concluído </span>
                <span *ngIf="element?.status?.nome === 'Cancelado'" class="badge bg-danger text-xs">Cancelado</span>
                <span *ngIf="element?.status?.nome === 'NaoImplementado'" class="badge bg-warning text-xs">Não Implementado</span>
                <span *ngIf="element?.status?.nome === 'ImplementadoParcialmente'" class="badge bg-implementado-parcialmente text-xs">Implementado Parcialmente</span>
                <span *ngIf="element?.status?.nome === 'ImplementadoTotalmente'" class="badge bg-primary text-xs">Implementado Totalmente</span>

                <ng-container *ngIf="element?.status?.codigo === 6">
                    <i 
                    class="fas fa-info-circle"
                    [matTooltip]="formatarTooltipCanc(element)" 
                    matTooltipClass="tooltip-cancelamento"
                    matTooltipPosition="above" 
                    style="cursor: pointer; margin-left: 0.5rem;">
                    </i>
                </ng-container>

                <ng-container *ngIf="element?.justificativaMonitoramentoFin">               
                    <i 
                    class="fas fa-info-circle"
                    [matTooltip]="formatarTooltipMonitoramentoFin(element)" 
                    matTooltipClass="tooltip-monitoramentoFin"
                    matTooltipPosition="above" 
                    style="cursor: pointer; margin-left: 0.5rem;">
                    </i>
                </ng-container>

            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumn"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumn" (click)="selecionar(row)" class="clickable"
            [ngClass]="{'bg-light': selectedModel?.id === row.id && selectedModel?.grupo === row.grupo}"></tr>
    </table>

    <h5 [hidden]="!semDados" class="table-no-data">Nenhum registro encontrado</h5>

    <mat-paginator class="mt-4" [pageSizeOptions]="[15, 30, 50]" showFirstLastButtons [length]="totalItens"
        (page)="selectedModel = null; pageEvent = pageChanged($event)">
    </mat-paginator>
</div>